import { render, staticRenderFns } from "./MediaSettings.vue?vue&type=template&id=8f49b470&scoped=true&lang=pug"
import script from "./MediaSettings.vue?vue&type=script&lang=js"
export * from "./MediaSettings.vue?vue&type=script&lang=js"
import style0 from "./MediaSettings.vue?vue&type=style&index=0&id=8f49b470&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f49b470",
  null
  
)

export default component.exports